"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M22 11V9L12 2 2 9v2h2v9H2v2h20v-2h-2v-9zm-4 9H6V9h12z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "m10 14 2 3 2-3v4h2v-7h-2l-2 3-2-3H8v7h2z"
}, "1")], 'MuseumOutlined');